export const AutoStatuses = {
  ON: "ON",
  OFF: "OFF"
};
